/**
 * サンプルクラス
 * @constructor
 */
class SpMenu {
  constructor() {
    this.$navButton = $('.js-spBtn');
    this.$navWrap = $('.js-spWrap');
    this.ww = window.innerWidth;
}
  /**
   * サンプル
   */
  init() {
    
      this.$navButton.on('click', (e) => {
          this.openMenu(e.currentTarget);
      }); 
      $('.js-nav').on('click', (e) => {
          this.closeMenu(e.currentTarget);
      });

    //アコーディオン
    $('.js-acc').on('click',function () {
      $(this).next('.js-spNav').slideToggle(500);
      if ($(this).children(".js-icon").hasClass('active')) {
          $(this).children(".js-icon").removeClass('active');
      }　else {
          $(this).children(".js-icon").addClass('active');
      }
      return false;
  });

  }
    openMenu(el) {
      $(el).toggleClass('is-active');
      this.$navWrap.toggle();
      document.body.classList.toggle('open');

      return false;
  }
  closeMenu(el) {
      if ($('.js-spBtn').hasClass('is-active')) { 
          $('.js-spWrap').fadeOut(200);
          $('.js-spBtn').removeClass('is-active');
          // $('.l-header').removeClass('is-open');
          document.body.classList.remove('open');
      }
  }
  
};

export default SpMenu;
